

import { useCallback } from 'react';
import { useAsync } from '../useAsync/useAsync';
import { replaceBucketKeys } from './utils';


export const useWithResolvedBucketKeys = (
{
  apiClient,
  data,
  organisationId,
  substitutedKeys,
  getOrganisationId,
  ...useAsyncOptions
},
deps = []) =>
{
  const fn = useCallback(async () => replaceBucketKeys({
    apiClient,
    data,
    organisationId,
    substitutedKeys,
    getOrganisationId
  }), deps);

  return useAsync({ fn, ...useAsyncOptions }, [fn]);
};